import { render, staticRenderFns } from "./Historia.vue?vue&type=template&id=e752f244"
import script from "./Historia.vue?vue&type=script&lang=ts"
export * from "./Historia.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports